import { request } from "../";
import config from "../../../config/common";
import { isTestEndpoint } from "../../../state/modules/config/selectors";
import { isUrlWithQueryString } from "../../../state/modules/search";
import { BRANDS_REQUEST } from "../constants";
import { cidToAlias } from "./cidToAlias";

const { baseUrl, timeout, brands } = config.api.navigation;
const requestTimeout = parseInt(timeout, 10);

export const getNavigationApiDefaults = (country) => {
  const { defaultLanguage: lang, keyStoreDataversion, countryCode } = country;

  const defaults = {
    lang,
    country: countryCode,
  };

  /*
    On the clientside, a keystoredataversion cookie will exist, provided by Sitechrome, therefore no need to pass in the URL
    */
  if (CLIENT) {
    return defaults;
  }

  return {
    ...defaults,
    keyStoreDataversion,
  };
};

/*
We expect to be able to pass the cid to nav api in the future, but until then we need to map them ourselves.
*/

export const getBrands = ({ country, query: { cid }, xSiteOrigin, uuid }) => {
  const alias = cidToAlias[cid];

  if (!alias) {
    const error = new Error(`The cid parameter (${cid}) isn't a brands page`);

    return Promise.reject(error);
  }

  const params = {
    alias,
    ...getNavigationApiDefaults(country),
  };
  const queryString = new URLSearchParams(params).toString();
  let url = `${baseUrl}${brands}?${queryString}`;

  if (isTestEndpoint(url)) {
    const symbol = isUrlWithQueryString(url) ? "&" : "?";

    url = `${url}${symbol}x-site-origin=${xSiteOrigin}`;
  }

  return request(url, { timeout: requestTimeout }, BRANDS_REQUEST, uuid);
};
